import { useQuery } from '@tanstack/react-query';

import { Declaration } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeclaration = (id: string) =>
  useQuery({
    queryKey: ['declaration', id],
    queryFn: async (): Promise<Declaration> => {
      try {
        if (id) {
          const result = await apiClient.declarations.getDeclaration.query({ params: { id } });
          if (result.status !== 200) throw result.body;

          return result.body.data as Declaration;
        }
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration details');
      }
    },
    enabled: !!id,
  });
